module.exports = __webpack_public_path__ + "static/img/logo-ditu.12159b5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/logo-ditu.jpg
// module id = ICUy
// module chunks = 2